export const convertRealStoryInfoToViewModel = (data: any): any => ({
  author: data.author || '',
  subtitle: data.subtitle || '',
  featuredQuote: data.featuredQuote || '',
  photoUrl: data.photoUrl || '',
  instagramHandle: data.instagramHandle || '',
  body: data.body || '',
  tags: data.tags && data.tags.length ? [...data.tags] : [],
});
